import { mobileSearchTenants } from "@/api/generated";
import { queryOptions } from "@tanstack/react-query";

export const familyDiscoveryQueries = {
  all: () => ["family-discovery"] as const,
  /** Families whose name matches the visitor's search on the landing page. */
  search: (query: string) =>
    queryOptions({
      queryKey: [...familyDiscoveryQueries.all(), "search", query] as const,
      queryFn: async ({ signal }) => (await mobileSearchTenants({ query: { query }, signal })).data.data.families,
    }),
};
